import image from 'shared/assets/images/integrationsSliders/salesloft/salesloft.png'
import { LINK_AMPERSAND_INTEGRATION_GUIDE } from 'shared/constants/links'
import { type IntegrationDetailsData } from 'entities/Integrations/lib/integrationsDescription'

export const salesloft: IntegrationDetailsData = {
  subheadline: 'Enhance your sales engagement platform with direct messaging capabilities.',
  overview:
    'Connect Salesmsg with Salesloft to streamline your workflow and keep your sales engagement platform up to date. When you engage with contacts through Salesmsg, relevant information flows to Salesloft, ensuring your records stay current without manual data entry.',
  keyBenefits: [
    'Quick setup through the Salesmsg App Marketplace',
    'Reduce manual data entry and improve workflow efficiency',
    'Seamless integration between your messaging and sales engagement workflows',
  ],
  images: [image],
  docs: LINK_AMPERSAND_INTEGRATION_GUIDE,
}
